import { useHistory, useLocation } from 'react-router-dom'
import { ButtonGroup } from 'stories/components'

import { ManageUtmAnalysis } from '../ManageUtmAnalysis'
import { ManageUtmLogs } from '../ManageUtmLogs'

const tabs = {
  analysis: 'UTM Analysis',
  logs: 'UTM Logs',
}

export const Utm = () => {
  const location = useLocation()
  const navigate = useHistory()
  const params = new URLSearchParams(location.search)
  const tab = params.get('tab') === 'logs' || location.pathname.endsWith('/utmLogs') ? 'logs' : 'analysis'

  const onChange = (next: string) => {
    const query = new URLSearchParams()
    query.set('tab', next)
    const keyword = params.get('keyword')
    if (next === 'logs' && keyword) query.set('keyword', keyword)
    navigate.push(`/admin_tool/utm?${query.toString()}`)
  }

  return (
    <div>
      <h1 className="text-2xl font-bold flex items-center pb-4">UTM</h1>
      <ButtonGroup title={tabs} value={tab} onChange={onChange} />
      <div className="mt-4">{tab === 'logs' ? <ManageUtmLogs /> : <ManageUtmAnalysis />}</div>
    </div>
  )
}
